import { mapDTO } from '@twistezo/ts-dto-mapper'

import { floatPercentFromDTO } from 'utils/number'
import { DomainRefresher } from '../../types/DomainRefresher'
import { DomainRefresherDTO } from '../types/domainRefresherDTO'

export const domainRefresherFromDTO = (from: DomainRefresherDTO) =>
  mapDTO<DomainRefresherDTO, DomainRefresher>({ from }).transform(domainRefresherDTO => {
    const {
      createdAt,
      desktopAdThreshold,
      desktopRefreshInterval,
      mobileAdThreshold,
      mobileRefreshInterval,
      updatedAt,
    } = domainRefresherDTO

    return {
      ...domainRefresherDTO,
      createdAt: new Date(createdAt),
      desktopAdThreshold: floatPercentFromDTO(desktopAdThreshold),
      desktopRefreshInterval: desktopRefreshInterval / 1000,
      mobileAdThreshold: floatPercentFromDTO(mobileAdThreshold),
      mobileRefreshInterval: mobileRefreshInterval / 1000,
      updatedAt: new Date(updatedAt),
    }
  })
